import {
  car,
  css,
  estate,
  express,
  git,
  github,
  html,
  javascript,
  linkedin,
  mongodb,
  nextjs,
  nodejs,
  pricewise,
  react,
  redux,
  snapgram,
  tailwindcss,
  threads,
  typescript,
  puppeteer,
  microservices,
  webScraping,
  blackstraw,
  tutorbin,
  gmail,
} from "../assets/icons";

export const skills = [
  {
    imageUrl: css,
    name: "CSS",
    type: "Frontend",
  },
  {
    imageUrl: express,
    name: "Express",
    type: "Backend",
  },
  {
    imageUrl: git,
    name: "Git",
    type: "Version Control",
  },
  {
    imageUrl: github,
    name: "GitHub",
    type: "Version Control",
  },
  {
    imageUrl: html,
    name: "HTML",
    type: "Frontend",
  },
  {
    imageUrl: javascript,
    name: "JavaScript",
    type: "Frontend",
  },
  {
    imageUrl: mongodb,
    name: "MongoDB",
    type: "Database",
  },
  {
    imageUrl: nextjs,
    name: "Next.js",
    type: "Frontend",
  },
  {
    imageUrl: nodejs,
    name: "Node.js",
    type: "Backend",
  },
  {
    imageUrl: react,
    name: "React",
    type: "Frontend",
  },
  {
    imageUrl: redux,
    name: "Redux",
    type: "State Management",
  },
  {
    imageUrl: tailwindcss,
    name: "Tailwind CSS",
    type: "Frontend",
  },
  {
    imageUrl: typescript,
    name: "TypeScript",
    type: "Frontend",
  },
  {
    imageUrl: puppeteer,
    name: "Puppeteer",
    type: "Testing/Scraping",
  },
  {
    imageUrl: webScraping,
    name: "Web Scraping",
    type: "Scraping",
  },
  {
    imageUrl: microservices,
    name: "Microservices",
    type: "Backend",
  },
];

export const experiences = [
  {
    title: "Software Developer",
    company_name: "Blackstraw AI",
    icon: blackstraw,
    iconBg: "#accbe1",
    date: "December 2022 - December 2023",
    points: [
      "Designed and built a high-impact web scraping project for 200k users across multiple platforms (Amazon, Gmail, Walmart, Instacart).",
      "Developed and managed APIs for user data storage, web scraping, and streamlined data management.",
      "Optimized accessibility and business processes, resulting in a 40% reduction in data retrieval time and a 25% increase in overall system efficiency.",
      "Created a centralized configuration system accessible via API resulting in a 50% reduction in application releases and server deployments.",
    ],
  },
  {
    title: "Software Developer",
    company_name: "Tutorbin",
    icon: tutorbin,
    iconBg: "#fbc3bc",
    date: "October 2021 - December 2022",
    points: [
      "•Developed and maintained python Django based application",
      "Automated manual Tutor Assignment processes for faster student response times by 40%.",
      "•Revamped Front-end applications to Next.js and enhance performance by 1.3 times.",
      "•Improved code abstraction, technology utilization in frontend project to reduce development time by 50%.",
      "Developed user-friendly landing pages using Next.js and CMS Strapi for easy content editing. reducing content editing time by developers by 90%.",
    ],
  },
];

export const socialLinks = [
  {
    name: "Gmail",
    iconUrl: gmail,
    link: "mailto:adarshsahu1996@gmail.com",
  },
  {
    name: "GitHub",
    iconUrl: github,
    link: "https://github.com/Adarsh-hash-dot",
  },
  {
    name: "LinkedIn",
    iconUrl: linkedin,
    link: "https://www.linkedin.com/in/adarsh-sahu-2a7065140/",
  },
];

export const projects = [
  {
    iconUrl: pricewise,
    theme: "btn-back-red",
    name: "ChatUIReact",
    description:
      "Developed a web application that has UI for chatting with users using ReactJS.",
    link: "https://adarsh-hash-dot.github.io/ChatUIReact/",
    githubLink: "https://github.com/Adarsh-hash-dot/ChatUIReact",
  },
  {
    iconUrl: threads,
    theme: "btn-back-green",
    name: "ContactKeeper",
    description:
      "Created a web application that helps to create and save contacts",
    link: "https://adarsh-hash-dot.github.io/ContactKeeper/",
    githubLink: "https://github.com/Adarsh-hash-dot/ContactKeeper",
  },
  {
    iconUrl: car,
    theme: "btn-back-blue",
    name: "HeroKeeper",
    description: "Designed and built a web application to save heros.",
    link: "https://adarsh-hash-dot.github.io/HeroKeeper/",
    githubLink: "https://github.com/Adarsh-hash-dot/HeroKeeper",
  },
  {
    iconUrl: snapgram,
    theme: "btn-back-pink",
    name: "NSE-Stock-data-parser",
    description:
      "Developed a script that helps scrape data from nse website for the given list of stocks.",
    githubLink: "https://github.com/Adarsh-hash-dot/NSE-Stock-data-parser",
  },
  {
    iconUrl: estate,
    theme: "btn-back-black",
    name: "3d-protfolio",
    description:
      "Developed a personal website using react.js, react fiber and threejs.",
    link: "/",
    // githubLink: "https://github.com/Adarsh-hash-dot/3d-protfolio",
  },
  // {
  //   iconUrl: summiz,
  //   theme: "btn-back-yellow",
  //   name: "AI Summarizer Application",
  //   description:
  //     "App that leverages AI to automatically generate concise & informative summaries from lengthy text content, or blogs.",
  //   link: "https://github.com/adrianhajdin/project_ai_summarizer",
  // },
];
